export default __webpack_public_path__ + "static/avatar-924767718d84cbdecc1e1bc2c46f1bcf.png";